import { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import { useRoutes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./App.css";
import { routes } from "./routes";

function App() {
  function RouteLayout({ path }) {
    const element = useRoutes(path);
    return element;
  }
  return (
    <>
      <Toaster position="top-right" />
      <Suspense
        fallback={
          <div className="mainLoader">
            <Spinner animation="border" />
          </div>
        }
      >
        <RouteLayout path={routes()} />
      </Suspense>
    </>
  );
}

export default App;
